import React, { useState, useRef, useEffect } from "react";
import { HiMenu } from "react-icons/hi";
import { IoCloseOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const Nav = ({ navOptions, reserve, navigateToRoute }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null); // Ref to the mobile menu

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  // Close the menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    const handleEscapeKey = (event) => {
      if (event.key === "Escape") {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("keydown", handleEscapeKey);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscapeKey);
    }

    // Cleanup
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <>
      <nav className="flex w-1/3 justify-end relative">
        <div className="hidden w-full md:flex items-center justify-end gap-8">
          {navOptions.map((navOption) =>
            navigateToRoute ? (
              <Link
                key={navOption}
                to={`/${navOption}`}
                title={navOption}
                className="text-2xl m-2 hover:brightness-125"
              >
                {navOption}
              </Link>
            ) : (
              <a
                href={`#${navOption}`}
                title={navOption}
                className="text-2xl m-2 hover:brightness-125"
              >
                {navOption}
              </a>
            )
          )}
          {reserve && (
            <a href="#reserve" title="reserve">
              <div className="text-2xl text-white bg-bigblue rounded-xl hover:brightness-125 flex align-center justify-center m-2 px-2">
                reserve
              </div>
            </a>
          )}
        </div>
        {/* MOBILE VIEW */}
        <div className="md:hidden flex items-center text-3xl mx-2">
          <button onClick={toggleNavbar}>
            {isOpen ? <IoCloseOutline /> : <HiMenu />}
          </button>
        </div>
      </nav>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            ref={menuRef}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.1 }}
            className="flex flex-col w-full items-center basis-full absolute top-full left-1/2 -translate-x-1/2 bg-white rounded-b-lg shadow-xl py-2"
          >
            {navOptions.map((navOption) =>
              navigateToRoute ? (
                <Link
                  key={navOption}
                  to={`/${navOption}`}
                  title={navOption}
                  className="text-3xl m-4 hover:brightness-125"
                  onClick={toggleNavbar}
                >
                  {navOption}
                </Link>
              ) : (
                <a
                  href={`#${navOption}`}
                  title={navOption}
                  className="text-3xl m-4 hover:brightness-125"
                  onClick={toggleNavbar}
                >
                  {navOption}
                </a>
              )
            )}
            {reserve && (
              <a
                href="#reserve"
                title="reserve"
                className="text-3xl m-4 hover:brightness-125"
                onClick={toggleNavbar}
              >
                reserve
              </a>
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Nav;
